import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Calendar, Newspaper, Settings, LogOut } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/LangToggle";

const NAV = [
  { to: "/admin", key: "dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/members", key: "members", icon: Users },
  { to: "/admin/events", key: "events", icon: Calendar },
  { to: "/admin/news", key: "news", icon: Newspaper },
  { to: "/admin/settings", key: "settings", icon: Settings },
];

export default function AdminLayout() {
  const { t, logout } = useApp();
  const navigate = useNavigate();
  const signOut = async () => { await logout(); navigate("/", { replace: true }); };

  return (
    <div className="min-h-screen md:flex">
      {/* Sidebar (desktop) / top (mobile) */}
      <aside className="md:w-64 md:min-h-screen border-b md:border-b-0 md:border-r border-[color:var(--cu-border)] px-5 py-6 md:sticky md:top-0 md:h-screen" style={{ background: "var(--cu-charcoal)" }}>
        <div className="flex items-center justify-between md:block">
          <Logo size="sm" />
          <div className="md:mt-2"><LangToggle /></div>
        </div>
        <div className="eyebrow mt-4 md:mt-6 mb-4">{t("admin")}</div>
        <nav className="flex md:flex-col gap-2 overflow-x-auto scrollbar-none">
          {NAV.map(({ to, key, icon: Icon, end }) => (
            <NavLink key={key} to={to} end={end} data-testid={`admin-nav-${key}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors ${isActive ? "text-[color:var(--cu-black)]" : "text-[color:var(--cu-muted)] hover:text-[color:var(--cu-gold-light)]"}`}
              style={({ isActive }) => isActive ? { background: "linear-gradient(135deg,#BF953F,#AA771C)" } : {}}>
              <Icon size={17} /> {t(key)}
            </NavLink>
          ))}
          <button onClick={signOut} data-testid="admin-signout-button" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-[color:var(--cu-muted)] hover:text-red-400 whitespace-nowrap">
            <LogOut size={17} /> {t("sign_out")}
          </button>
        </nav>
      </aside>

      <main className="flex-1 min-w-0 px-5 md:px-8 py-8 max-w-5xl">
        <Outlet />
      </main>
    </div>
  );
}
